import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { addPolicyData, getPolicyList, publishedPolicy } from "./policyService";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import TosterService from "../../../Services/Toster-Service/TosterService";
import {
  GetMasterTypeData,
  uploadDoc,
} from "../../../Services/Global-Services/GlobalServices";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { TostMsg } from "../../../App";
import { Dropdown } from "primereact/dropdown";
import UploadFile_KEYS from "../../../Services/Global-Services/UploadFile_Keys";
import { Editor } from "primereact/editor";
import { isEqual } from "lodash";

const ComponentLoader = React.lazy(() =>
  import("../../../Shared/Sidebar/ComponentLoader")
);
const defaultImage = "/images/no-data-found/feed_dummy.png";

function AddPolicy() {
  const { GUID } = useParams();
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const toster = useContext(TostMsg);
  const history = useHistory();
  const [policyEditDetailList, setPolicyEditDetailList] = useState([]);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [Isloading, setIsloading] = useState(false);
  const [policyCategoryType, setPolicyCategoryType] = useState([]);
  const [editPolicyDoc, setEditPolicyDoc] = useState([]);
  const [headerTitle, setHeaderTitle] = useState("");
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    getMasterTypeList();
    GetMasterSystemAlertList();
    if (GUID) {
      getPolicyEditData();
    }
  }, []);

  const addPolicyValidation = Yup.object().shape({
    policyName: Yup.string().required("Policy name is required"),
    shortDesc: Yup.string().required("Title desc is required"),
    PolicyCategoryId: Yup.string().required("Policy category is required"),
    policyDocuments: Yup.string().required("Policy Document is required"),
    policyDetails: Yup.array().of(
      Yup.object().shape({
        ParagraphHeader: Yup.string().required("Paragraph Header is required"),
        ParagraphDescription: Yup.string().required(
          "Paragraph Description is required"
        ),
      })
    ),
  });

  const generateUpdatedDocs = (documentPaths, editPolicyDoc) => {
    const docPaths = documentPaths.split(",");
    const updatedDocs = docPaths.map((path) => {
      const existingDoc = editPolicyDoc.find(
        (doc) => doc.DocumentPath === path
      );
      if (existingDoc) {
        return existingDoc;
      } else {
        return {
          Id: 0,
          DocumentPath: path,
          DocumentName: path.split("/").pop(),
        };
      }
    });
    return updatedDocs;
  };

  const addPolicyForm = useFormik({
    enableReinitialize: true,
    initialValues: {
      policyName: "",
      shortDesc: "",
      PolicyCategoryId: "",
      policyDocuments: "",
      policyDetails: [
        {
          Id: 0,
          ParagraphHeader: "",
          ParagraphDescription: "",
        },
      ],
    },
    validationSchema: addPolicyValidation,
    onSubmit: async (data) => {
      const updatedDocList = generateUpdatedDocs(
        data.policyDocuments,
        editPolicyDoc
      );
      const params = {
        Id: policyEditDetailList[0]?.Id ?? 0,
        IsPublished: 0,
        PolicyName: data.policyName,
        ShortDesc: data.shortDesc,
        OrgPolicyCategoryId: data.PolicyCategoryId,
        CreatedBy: userDetails.EmpId,
        policyDetails: data.policyDetails,
        policyDocuments: updatedDocList,
      };
      try {
        let policyData = await addPolicyData(params);
        if (policyData) {
          if (policyEditDetailList[0]?.Id ?? 0) {
            GetMasterSystemAlertList("Policy_Updated");
          } else {
            GetMasterSystemAlertList("Policy_Added");
          }
          addPolicyForm.resetForm();
          setTimeout(() => {
            history.push("/Policylist");
          }, 1000);
        }
      } catch (error) {}
    },
  });

  const addPolicyDetail = () => {
    const newDetail = {
      Id: 0,
      ParagraphHeader: "",
      ParagraphDescription: "",
    };
    addPolicyForm.setFieldValue("policyDetails", [
      ...addPolicyForm.values.policyDetails,
      newDetail,
    ]);
  };

  const removePolicyDetail = (index) => {
    const newDetails = [...addPolicyForm.values.policyDetails];
    newDetails.splice(index, 1);
    addPolicyForm.setFieldValue("policyDetails", newDetails);
  };

  useEffect(() => {
    if (policyEditDetailList.length > 0) {
      const pathsString = policyEditDetailList[0]?.policyDocumentlist
        ?.map((doc) => doc.PolicyDocumentPath)
        .join(",");

      const mappedDetails = policyEditDetailList[0]?.policyDetailsList?.map(
        (item) => ({
          Id: item.Id,
          ParagraphHeader: item.ParagraphHeader,
          ParagraphDescription: item.ParagraphDescription,
        })
      );

      const policyEditValue = {
        policyName: policyEditDetailList[0]?.PolicyName,
        shortDesc: policyEditDetailList[0]?.ShortDesc,
        PolicyCategoryId: policyEditDetailList[0]?.OrgPolicyCategoryId,
        policyDocuments: pathsString,
        policyDetails: mappedDetails || [],
      };
      // let updateDocs = policyEditDetailList[0]?.policyDocumentlist?.map(
      //   (item) => {
      //     return {
      //       Id: item.Id,
      //       DocumentPath: item.PolicyDocumentPath,
      //       DocumentName: item.PolicyDocumentName,
      //     };
      //   }
      // );

      const updateDocs =
        policyEditDetailList[0]?.policyDocumentlist?.map((item) => ({
          Id: item.Id,
          DocumentPath: item.PolicyDocumentPath,
          DocumentName: item.PolicyDocumentName,
        })) || [];

      addPolicyForm.setValues(policyEditValue);

      setEditPolicyDoc(updateDocs);
    }
  }, [policyEditDetailList]);

  async function getMasterTypeList() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "PolicyCategory",
    };
    try {
      const data = await GetMasterTypeData(params);
      setPolicyCategoryType(data?.Data);
    } catch (error) {
      setIsloading(false);
    }
  }

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    uploadPolicyDocFile(selectedFile);
  };

  async function uploadPolicyDocFile(file) {
    if (file) {
      setIsloading(true);
      const formData = new FormData();
      formData.append("files", file);
      let params = {
        UploadType: UploadFile_KEYS?.Policy,
        RefId: policyEditDetailList[0]?.Id ?? 0,
      };
      const response = await await uploadDoc(params, formData);
      const data = await response;
      const policyFormData = data?.Data;
      setUploadedImages(data?.Data[0]);
      const existingImages = addPolicyForm.values.policyDocuments || "";
      const existingImageArray = existingImages
        ? existingImages.split(",")
        : [];
      const updatedImages = [...existingImageArray, ...policyFormData];
      const curuntArticleImage = updatedImages.join(",");
      addPolicyForm.setFieldValue("policyDocuments", curuntArticleImage);
      setIsloading(false);
    } else {
      toster.current.warn("No file selected");
      setIsloading(false);
    }
  }

  async function getPolicyEditData() {
    setIsloading(true);
    const param = {
      OrgId: userDetails?.OrgId,
      GUID: GUID,
      CategoryId: 0,
      IsPublished: 0,
      PageNumber: 1,
      PageSize: 10,
    };
    try {
      let projectDetailData = await getPolicyList(param);
      setPolicyEditDetailList(projectDetailData?.Data?.policyList);
      addPolicyForm.setFieldValue(projectDetailData?.Data?.policyList);
      setIsloading(false);
    } catch {
      setIsloading(false);
    }
  }

  async function GetMasterSystemAlertList(message) {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == "policy_add_edit") {
        setHeaderTitle(msg?.Desc);
      }
    });
  }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const handleDeleteImage = (image) => {
    const deleteThisUrl = image;
    const documentValue = addPolicyForm?.values?.policyDocuments || "";
    const fileData = documentValue.split(",");
    const updatedData = fileData.filter((doc) => doc !== deleteThisUrl);
    addPolicyForm.setFieldValue("policyDocuments", updatedData.join(","));
  };

  const policyPublished = async () => {
    if (policyEditDetailList) {
      let params = {
        PolicyId: policyEditDetailList[0]?.Id,
        ModifiedBy: userDetails?.EmpId,
      };
      try {
        await publishedPolicy(params);
        toster.current.success("Policy Updated Successfully.");
        setTimeout(() => {
          history.push("/Policylist");
        }, 1000);
      } catch (error) {
        console.error("Error Occurs", error);
      }
    } else {
      console.error("Error Occurs");
    }
  };

  const determineDocType = (DocData) => {
    const imageExtensions = /\.(jpg|jpeg|png|gif|bmp)$/i;
    const pdfExtension = /\.pdf$/i;

    if (imageExtensions.test(DocData)) {
      return "image";
    } else if (pdfExtension.test(DocData)) {
      return "pdf";
    } else {
      return "Doc";
    }
  };

    const headerTemplate = (
    <span className="ql-formats0">
      <select className="ql-size">
        <option value="small"></option>
        <option selected></option>
        <option value="large"></option>
        <option value="huge"></option>
      </select>
      <select className="ql-font">
        <option selected></option>
        <option value="serif"></option>
        <option value="monospace"></option>
      </select>
      <button className="ql-bold"></button>
      <button className="ql-italic"></button>
      <button className="ql-underline"></button>
      <select className="ql-color"></select>
      <select className="ql-background"></select>
      <button className="ql-list" value="ordered"></button>
      <button className="ql-list" value="bullet"></button>
      <select className="ql-align"></select>
      <button className="ql-link"></button>
      <button className="ql-code-block"></button>
      <button className="ql-clean"></button>
    </span>
  );

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="form-head d-flex flex-wrap align-items-center">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">
                  {GUID ? "Edit" : "Add"} Policy
                </h2>
                <p className="text-light">{headerTitle}</p>
              </div>
              <div className="rightside-tabs">
                {GUID && (
                  <button
                    className="add-btncssq me-2"
                    onClick={() => policyPublished()}
                  >
                    {policyEditDetailList[0]?.IsPublished
                      ? "UnPublish"
                      : "Publish"}
                  </button>
                )}
                <Link to="/Policylist" className="add-btncss-dark">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-arrow-left-short me-2"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                    ></path>
                  </svg>
                  Back
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-12">
          <form onSubmit={addPolicyForm.handleSubmit}>
            <div className="row mt-5 justify-content-center">
              <div className="col-xl-8">
                <div className="row g-3" style={{ padding: (4 % 2) % 0 }}>
                  <div className="col-md-6">
                    <div className="cover-form">
                      <label className="form-label">Policy Name</label>
                      <input
                        type="text"
                        name="policyName"
                        className={
                          "form-control" +
                          (addPolicyForm.errors.policyName &&
                          addPolicyForm.touched.policyName
                            ? " is-invalid"
                            : "")
                        }
                        onChange={addPolicyForm.handleChange}
                        value={addPolicyForm.values.policyName}
                      />
                      <div className="invalid-feedback">
                        {addPolicyForm.errors.policyName &&
                        addPolicyForm.touched.policyName
                          ? addPolicyForm.errors.policyName
                          : null}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="cover-form p-dropdown-border">
                      <label className="form-label">Policy Category</label>
                      <Dropdown
                        name="PolicyCategoryId"
                        value={addPolicyForm.values.PolicyCategoryId}
                        onFocus={(e) => e.target.click()}
                        onChange={(e) => {
                          addPolicyForm.setFieldValue(
                            "PolicyCategoryId",
                            e.value
                          );
                        }}
                        options={policyCategoryType}
                        optionLabel="Name"
                        optionValue="Id"
                        filter
                      />
                      <div className="invalid-feedback">
                        {addPolicyForm.errors.PolicyCategoryId &&
                        addPolicyForm.touched.PolicyCategoryId
                          ? addPolicyForm.errors.PolicyCategoryId
                          : null}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="cover-form">
                      <label className="form-label">Short Description</label>
                      <div className="bg-white w-100">
                        <Editor
                          name="shortDesc"
                          value={addPolicyForm.values.shortDesc}
                          onTextChange={(e) => {
                            addPolicyForm.setFieldValue(
                              "shortDesc",
                              e.htmlValue
                            ); // triggers validation
                          }}
                          headerTemplate={headerTemplate}
                          style={{ height: "320px" }}
                          onBlur={() =>
                            addPolicyForm.setFieldTouched("shortDesc", true)
                          }
                        />
                      </div>
                      <div className="invalid-feedback">
                        {addPolicyForm.errors.shortDesc &&
                        addPolicyForm.touched.shortDesc
                          ? addPolicyForm.errors.shortDesc
                          : null}
                      </div>
                    </div>
                  </div>
                  {addPolicyForm.values.policyDetails?.map((detail, index) => (
                    <div className="col-md-12" key={detail.Id || index}>
                      <h4 className="policy-tab-haed">Paragraph {index + 1}</h4>
                      <div className="add-sectio">
                        <div className="row g-3">
                          <div className="col-xl-12">
                            <div className="cover-form">
                              <label>Paragraph Header</label>
                              <input
                                name={`policyDetails[${index}].ParagraphHeader`}
                                // value={detail.ParagraphHeader}
                                value={
                                  addPolicyForm.values.policyDetails[index]
                                    .ParagraphHeader
                                }
                                onChange={addPolicyForm.handleChange}
                                onBlur={addPolicyForm.handleBlur}
                                className={
                                  "form-control" +
                                  (addPolicyForm.errors.policyDetails?.[index]
                                    ?.ParagraphHeader &&
                                  addPolicyForm.touched.policyDetails?.[index]
                                    ?.ParagraphHeader
                                    ? " is-invalid"
                                    : "")
                                }
                              />
                            </div>
                            <div className="invalid-feedback">
                              {addPolicyForm.errors.policyDetails?.[index]
                                ?.ParagraphHeader &&
                                addPolicyForm.touched.policyDetails?.[index]
                                  ?.ParagraphHeader && (
                                  <div style={{ color: "red" }}>
                                    {
                                      addPolicyForm.errors.policyDetails[index]
                                        .ParagraphHeader
                                    }
                                  </div>
                                )}
                            </div>
                          </div>
                          <div className="col-xl-12">
                            <div className="cover-form">
                              <label>Description</label>
                              <div className="bg-white w-100">
                                <Editor
                                  name={`policyDetails[${index}].ParagraphDescription`}
                                  // value={detail.ParagraphDescription}
                                  value={
                                    addPolicyForm.values.policyDetails[index]
                                      .ParagraphDescription
                                  }
                                  headerTemplate={headerTemplate}
                                  style={{ height: "320px" }}
                                  onTextChange={(e) => {
                                    addPolicyForm.setFieldValue(
                                      `policyDetails[${index}].ParagraphDescription`,
                                      e.htmlValue
                                    ); // triggers validation
                                  }}
                                  onBlur={() =>
                                    addPolicyForm.setFieldTouched(
                                      `policyDetails[${index}].ParagraphDescription`,
                                      true
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="invalid-feedback">
                              {addPolicyForm.errors.policyDetails?.[index]
                                ?.ParagraphDescription &&
                                addPolicyForm.touched.policyDetails?.[index]
                                  ?.ParagraphDescription && (
                                  <div style={{ color: "red" }}>
                                    {
                                      addPolicyForm.errors.policyDetails[index]
                                        .ParagraphDescription
                                    }
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                        {index > 0 && (
                          <button
                            className="remove-paragraph"
                            type="button"
                            onClick={() => removePolicyDetail(index)}
                            disabled={
                              addPolicyForm.values.policyDetails.length === 1
                            }
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="currentColor"
                              className="bi bi-x-circle-fill"
                              viewBox="0 0 16 16"
                            >
                              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
                            </svg>
                          </button>
                        )}
                      </div>
                    </div>
                  ))}

                  <div className="col-md-12 mt-4">
                    <div className="btns-grp text-right">
                      <button
                        type="button"
                        onClick={addPolicyDetail}
                        className="add-click"
                      >
                        Add Paragraph
                      </button>

                      <button type="submit" className="savebutton">
                        {GUID ? "Update" : "Save"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3">
                {addPolicyForm.values.policyDocuments?.length > 0 ? (
                  addPolicyForm.values.policyDocuments
                    .split(",")
                    ?.map((image) => {
                      let DocType = determineDocType(image);
                      let ImageData = image?.split("/");
                      let lastIndex = ImageData?.length - 1;
                      let finelNameStore = ImageData[lastIndex];
                      return (
                        <div className="uploaded-policy-list">
                          <div className="list">
                            <div className="li-list">
                              {DocType == "Doc" && (
                                <div className="inner">
                                  <img
                                    src="/images/tickets/doc.png"
                                    className="w-100"
                                    alt="Doc"
                                  />
                                </div>
                              )}
                              {DocType == "image" && (
                                <img
                                  src={image || defaultImage}
                                  onError={handleImageError}
                                  className="w-100"
                                  alt="Doc"
                                />
                              )}
                              {DocType == "pdf" && (
                                <div className="inner">
                                  <img
                                    src="/images/tickets/pdf.png"
                                    className="w-100"
                                    alt="Doc"
                                  />
                                </div>
                              )}
                              <div className="media-body px-0">
                                <h6
                                  className="mt-0 mb-0 fss-14"
                                  title={finelNameStore}
                                >
                                  {finelNameStore?.length > 15
                                    ? finelNameStore.slice(0, 15) + "..."
                                    : finelNameStore}
                                </h6>
                              </div>
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleDeleteImage(image)}
                                title="Delete"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  fill="currentColor"
                                  className="bi bi-x"
                                  viewBox="0 0 16 16"
                                >
                                  {" "}
                                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })
                ) : (
                  <></>
                )}
                <div className="invalid-feedback">
                  {addPolicyForm.errors.policyDocuments &&
                  addPolicyForm.touched.policyDocuments
                    ? addPolicyForm.errors.policyDocuments
                    : null}
                </div>
                <div className="loadfiles policyupload">
                  <label for="file-upload" className="custom-file-upload">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      fill="currentColor"
                      className="bi bi-paperclip"
                      viewBox="0 0 16 16"
                    >
                      <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0z" />
                    </svg>
                    Upload Policy
                  </label>
                  <input
                    type="file"
                    id="file-upload"
                    multiple={true}
                    className="form-control"
                    onChange={handleFileChange}
                    name="BannerImage"
                    accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"
                    style={{ display: " none" }}
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <TosterService ref={toster} />
      {Isloading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </>
  );
}

export default AddPolicy;
